




























import { Component, Vue } from 'vue-property-decorator'
import { AloCours, getDefaultAloCours } from '@/models/alo/AloCours'
import { AloError } from '@/models/alo/AloError'
import { getImageUrl } from '@/utils/images'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { directPayloadQuery } from '@/utils/api'
import apiFamily from '@/api/family'
import ListeTuileCoursItem from '@/components/shared/ListeTuileCoursItem.vue'
import { Tickets } from '@/models/alo/Tickets'
import { CmdTickets } from '@/models/alo/CmdTickets'
import { formatDate } from '@/filters/formatDate'

//{id:13, idActi:2, name:'Se sauver / Apprentissage', date:'2021-06-23 15:00', duree: 45, capacite:8, nbResa:4},
@Component({
  name:"ListeTuileCours",  
  props:{    
    items:Array,
    resas:{
      type:Array,
      default:()=>[]
    }
  },
  components: {ListeTuileCoursItem}
})
export default class ListeTuileCours extends Vue {    
  items!:Array<AloCours>    
  resas!:Array<number>
  reserving:boolean = false
  showInscription:boolean = false
  selectedCours:AloCours = getDefaultAloCours()
  selectedUsrId:number = 0
  selectedTicketId:number = 0
  nbTicketRestant:number = 0
  nbAbonnementRestant:number = 0
  tickets:Array<CmdTickets> = []


  get getImageUrl(){
    return getImageUrl
  }

  get participants()  {
    return this.$store.myGetters.user.membres
  }


  libelleCarte(it:CmdTickets){
    return it.crwId==0?it.libelle:`${it.libelle} (${it.nbTicket} restant(s)) expire ${formatDate(it.dateExpiration,'MMM YYYY')}`
  }
  

  created(){        
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  nbResa(idCours:Number) {
    return this.resas.filter(r => r == idCours).length
  }
  

  reserver(cours:AloCours) {
    //On verifie que la personne est connectée
    if(!this.$store.myGetters.isAuthenticated) {
      this.$confirm("Merci de vous authentifier avant de pouvoir réserver",{title: 'Attention',buttonTrueText:"Me connecter / Creer un compte",buttonFalseText:""} as VuetifyConfirmObject).then((answer)=>{
        if(answer){
          this.$store.myActions.AUTH_SET_REDIRECT_PATH(this.$route.path)
          this.$router.push({name:"Login"})
        }
      })
    }
        
    //on regarde si la personne a des tickets valide pour ce cours    
    this.reserving = true
    this.selectedTicketId = 0
    this.tickets = []
    directPayloadQuery(apiFamily.getAllowedTickets,{famId:this.$store.myGetters.user.famId,crsId:cours.id}).then((tickets:Array<CmdTickets>)=>{          
      if(tickets.length > 0){
        //affichge de la fenêtre de réservation        
        this.selectedCours = cours
        this.nbTicketRestant = tickets.filter(t => !t.isAbonement).reduce((total,t)=> total + t.nbTicket ,0)
        this.nbAbonnementRestant = tickets.filter(t => t.isAbonement).reduce((total,t)=> total + t.nbTicket ,0) 
        this.selectedUsrId = this.participants[0]?.id         
        this.showInscription = true;
        this.tickets = tickets
      }
      else{
        //pas de ticket message d'alerte
        this.$confirm("Vous ne possédez pas de tickets en cours de validité pour pouvoir réserver ce cours, Merci d'acheter un des forfaits donnant accès à cette activité afin de pouvoir réserver",{title: 'Attention',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject)
      }
    })
    .finally(()=>{
      this.reserving = false
    })    
  }  

  validInscription()  {
    this.reserving = true
    directPayloadQuery(apiFamily.inscription,{usrId:this.selectedUsrId,crsId:this.selectedCours.id,crwId:this.selectedTicketId}).then((resaOk:boolean)=>{          
      if(resaOk){        
        this.$emit("inscription")
        this.showInscription = false;
        this.$confirm("Merci, votre inscription à bien été prise en comptes vous allez recevoir un email de validation",{title: 'Inscription validée',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject)        
      }    
    })
    .catch((error)=>{      
      this.$confirm(error,{title: 'Erreur',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject).then(()=>{
        this.showInscription = false
      }) 
    })
    .finally(()=>{
      this.reserving = false
    })    
  }
}
